import $ from 'jquery'
import { trace } from 'rytm-helpers'


const onToggleInputValueClick = (e) => {
  e.preventDefault()
  const value = e.currentTarget.dataset.value
  const selector = e.currentTarget.dataset.target
  if (value && selector) {
    const target = document.querySelector(selector)
    if (target) {
      target.value = value
      target.classList.add("selected")
    }
  }
}

export const initEventForm = () => {
  $('body').on("click", 'a[data-toggle="inputValue"]', onToggleInputValueClick)
}